export default __webpack_public_path__ + "static/media/playstoreLogoCon.8c89c70d.svg";